module.exports = __webpack_public_path__ + "img/p4b__success_icon.bb89dc17.svg";